import {
  AppLayoutToolbar,
  Box,
  ContentLayout,
  SplitPanel,
} from '@cloudscape-design/components';
import { useState } from 'react';
import { useSplitPanel } from 'src/context/SplitPanelContext';
import AppRouter from 'src/AppRouter';
import AppBreadcrumbs from './AppBreadcrumbs';
import CustomSideNavigation from './CustomSideNavigation';
import { useUserPreferences } from 'src/store/userPreferences/useUserPreferences';
interface AppLayoutWrapperProps {
  children?: React.ReactNode;
}

const AppLayoutWrapper = ({ children }: AppLayoutWrapperProps) => {
  const { content, title, closeView, panelSize, setPanelSize } = useSplitPanel();
  const { userPreferences } = useUserPreferences();
  const hasNoPreferences = !userPreferences?.profileSettings?.businessUnit;
  const [navigationOpen, setNavigationOpen] = useState(true);
  const [splitPanelPreferences, setSplitPanelPreferences] = useState<any>({
    position: 'side',
  });
  return (
    <AppLayoutToolbar
      data-testid="app-layout-toolbar"
      headerSelector={'#topnav'}
      splitPanelOpen={content != null}
      onSplitPanelToggle={() => closeView()}
      contentType="form"
      splitPanelPreferences={splitPanelPreferences}
      onSplitPanelPreferencesChange={({ detail }) => setSplitPanelPreferences(detail)}
      splitPanelSize={panelSize}
      disableContentPaddings={true}
      splitPanel={
        <SplitPanel data-testid="split-panel" hidePreferencesButton={true} header={title}>
          {content}
        </SplitPanel>
      }
      toolsHide={true}
      onSplitPanelResize={(size) => {
        setPanelSize(size.detail.size);
      }}
      breadcrumbs={<AppBreadcrumbs />}
      navigationOpen={navigationOpen && !hasNoPreferences}
      onNavigationChange={({ detail }) =>
        !hasNoPreferences && setNavigationOpen(detail.open)
      }
      navigation={!hasNoPreferences ? <CustomSideNavigation /> : undefined}
      navigationHide={hasNoPreferences}
      content={
        <Box
          data-testid="content-box"
          padding={{ left: 'l', right: 'l', top: 's', bottom: 's' }}
        >
          <AppRouter />
        </Box>
      }
    />
  );
};

export default AppLayoutWrapper;
